export default __webpack_public_path__ + "static/media/oneDrive.9a752f08.svg";